var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharityColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CharityColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "26.407355%",
    x2: "99.999575%",
    y2: "31.0333639%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-14.9%",
    y: "-20.3%",
    width: "129.8%",
    height: "140.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.1805473%",
    y1: "51.6135159%",
    x2: "58.7590312%",
    y2: "68.288021%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.63857%",
    x2: "99.999575%",
    y2: "28.0035564%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.35051,52.9490983 C130.260364,42.942939 123.499443,33.477654 111.149499,26.3561534 C98.7995552,19.2346528 82.3930552,15.2682462 64.9949595,15.1781006 C47.5968639,15.1781006 31.2805159,19.0543605 19.0207171,26.0857156 C6.6707732,33.2072162 0,42.672503 0,52.6786623 C0,54.7520105 0,70.4373389 0,80.5336432 C0,82.6069914 2.88465829,84.2296173 6.40033587,84.2296173 C9.91601345,84.2296173 12.8006717,82.6069914 12.8006717,80.5336432 C12.8006717,72.4205414 18.1192613,64.8483125 28.0352747,59.169141 C37.8611423,53.4899696 51.0223951,50.3348773 64.9949595,50.4250229 C78.967524,50.5151685 92.1287768,53.5801193 102.04479,59.3494363 C105.92105,61.6030757 109.166296,64.1271464 111.600227,66.9216592 C109.166296,69.6260265 106.0112,72.0599646 102.225086,74.313604 C92.399218,79.9927754 79.2379634,83.1478677 65.265399,83.0577221 C61.7497214,83.0577221 58.8650644,84.6803343 58.8650644,86.7536825 C58.8650644,87.7452838 58.8650644,112.535326 58.8650644,114.608674 C58.8650644,115.600275 59.5862277,116.591871 60.7581202,117.22289 C61.9300126,117.853909 63.5526331,118.304634 65.265399,118.304634 C82.6634947,118.304634 98.9798444,114.428383 111.239643,107.397028 C123.499442,100.275527 130.260353,90.9003871 130.170207,80.8040827 C130.260353,75.9362215 130.35051,57.8169595 130.35051,52.9490983 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.5%",
    y: "-8.2%",
    width: "113.0%",
    height: "116.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.975918%",
    y1: "6.28571108%",
    x2: "72.0238948%",
    y2: "14.8571404%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.999676,45.2867893 C160.999676,44.0247512 160.278511,42.7627118 158.746036,41.7711104 C155.230359,39.4273254 148.108858,38.6160152 134.857459,39.0667431 C126.744357,39.3371798 119.442566,40.0583465 119.081983,40.0583465 C115.566306,40.4189288 117.729789,47.6305741 121.155321,47.3601373 C130.710752,46.4586815 140.89721,46.1882448 146.305944,46.4586815 C144.322741,47.9010108 140.446482,50.4250866 132.784108,54.3013467 C125.302025,58.0874607 118.000234,61.3326997 117.910088,61.4228452 C117.369217,89.6083626 117.158878,103.73117 117.279072,103.791267 C119.532711,105.053305 123.138524,105.233597 125.6626,104.151851 C130.079733,102.258793 160.819374,73.3220616 160.819374,70.437403 C160.999676,69.0852194 160.999676,45.7375172 160.999676,45.2867893 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-19.4%",
    y: "-12.9%",
    width: "138.9%",
    height: "125.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "36.8180876%",
    x2: "99.999575%",
    y2: "39.4027763%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.9948809,15.1781557 C66.2569188,15.1781557 67.4288099,15.178156 68.6908479,15.2683016 C74.55031,11.4821877 78.426571,9.49898493 80.7703558,8.5073836 C81.1309381,10.3102951 81.0407952,13.1949541 80.5900674,16.3500492 C84.917055,16.9810682 89.0637468,17.7923776 93.030152,18.8741245 C93.2104432,17.7022321 93.3907398,16.4401951 93.571031,15.0880115 C94.3823411,7.42563775 92.9400078,3.27894082 88.8834572,1.29573816 C86.4495267,0.0337001585 83.2042903,-0.32688214 80.0491953,0.304136862 C76.6236637,0.935155865 70.7641996,2.64792219 57.422655,11.3920426 C54.898579,13.1048085 52.4646479,14.7274278 50.4814453,16.0796114 C55.1690148,15.5387379 60.0368745,15.1781557 64.9948809,15.1781557 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.5%",
    y: "-7.9%",
    width: "106.9%",
    height: "115.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.746145,41.7711104 C155.230468,39.4273254 148.108968,38.6160152 134.857569,39.0667431 C131.612329,39.1568887 128.547371,39.3371798 125.93315,39.517471 C127.465624,41.8612559 128.63752,44.2951869 129.358684,46.7291175 C136.209747,46.3685352 142.519932,46.1882447 146.396191,46.4586815 C144.412989,47.9010107 140.536729,50.4250865 132.874356,54.3013465 C131.9729,54.7520744 131.071444,55.2028023 130.169989,55.6535302 C129.719261,59.7100812 128.096643,63.6764832 125.482422,67.3724518 C125.662713,67.2823062 125.752859,67.282309 125.93315,67.1921634 C126.203586,67.0118722 133.595521,63.7666343 141.438185,59.8002288 C156.492496,52.1378547 159.647593,48.7123222 160.639194,46.8192652 C161.54065,45.0163536 160.909639,43.123294 158.746145,41.7711104 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.2%",
    y: "-5.3%",
    width: "108.4%",
    height: "110.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.8482611,89.3680093 C59.6763688,88.7369903 58.9552055,87.7453876 58.9552055,86.7537863 C58.9552055,84.6804382 61.8398624,83.0578192 65.3555398,83.0578192 C79.3281034,83.0578192 92.4893573,79.9928727 102.315224,74.3137015 C112.141091,68.6345303 117.54982,61.0623017 117.54982,52.9492003 C117.54982,44.8360988 112.050949,37.2638702 102.134936,31.584699 C92.218923,25.9055278 78.9675198,22.570141 64.9949561,22.570141 C51.0223924,22.570141 37.8611403,25.6350918 28.0352733,31.314263 C18.2094062,36.9934342 12.8006711,44.6558087 12.8006711,52.6787642 C12.8006711,54.7521123 9.91601293,56.3747313 6.40033553,56.3747313 C2.88465813,56.3747313 0,54.7521123 0,52.6787642 C0,42.6726054 6.67077199,33.2073186 18.9305701,26.1759639 C31.1903683,19.1446091 47.5067172,15.1782039 64.9048119,15.2683495 C82.3029066,15.2683495 98.7093988,19.2347554 111.059342,26.3562557 C123.409285,33.477756 130.261246,42.9430414 130.261246,52.9492003 C130.350497,62.9553591 123.58958,72.4206403 111.329782,79.5421405 C99.0699834,86.6636408 82.7536345,90.5399058 65.3555398,90.4497602 C63.6427739,90.4497602 62.0201535,89.9990283 60.8482611,89.3680093 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-2.0%",
    width: "102.3%",
    height: "104.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CharityColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-129",
    transform: "translate(14.481552, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58395767,43.9383698 L53.9449348,23.7393227 L57.4226532,21.3920431 L58.6516571,20.5926998 C59.054121,20.3329976 59.4494324,20.0799804 59.8377457,19.8334665 L60.7810902,19.2387042 C71.7780159,12.3542615 76.9177919,10.8795093 79.9590454,10.3041369 C80.9930954,10.0973278 82.0368195,9.99702899 83.0584946,9.9999344 C85.1868439,9.99374302 87.2237701,10.4351608 88.8834534,11.2957382 C92.9400101,13.2789409 94.3823395,17.4256382 93.5710297,25.0880117 L93.3907375,26.4101464 C93.2705417,27.2715371 93.1503448,28.0928631 93.0301514,28.8741245 L92.9441376,28.8507156 L92.9400101,28.8741245 L92.882,28.8609344 L92.827,28.8709344 L93.3809792,29.0244778 C99.8827227,30.8577417 105.884717,33.3202577 111.149498,36.3561535 C117.752319,40.1636162 122.757538,44.6410332 125.999863,49.5128784 L128.02794,49.3803359 C129.89682,49.265086 131.932323,49.1599314 134.05635,49.0909026 L136.718122,49.0107356 C145.614347,48.7795427 151.548771,49.1768779 155.39386,50.2963867 C156.626031,50.6551384 157.643714,51.0880478 158.475663,51.5981962 L158.74614,51.7711105 C160.468124,52.8473549 161.219284,54.266243 160.999619,55.7096024 L160.963056,70.6975281 C160.93805,75.4566989 160.895973,79.6535766 160.82517,80.3856902 L160.819366,80.4374008 C160.819366,83.3220596 130.079727,112.258789 125.662598,114.151848 C123.138527,115.233597 119.532715,115.053307 117.279076,113.791267 C117.26889,113.786179 117.261871,113.646454 117.25769,113.387329 C115.431091,114.789574 113.422531,116.129021 111.239639,117.397026 C98.9798431,124.428383 82.6634903,128.304634 65.2653961,128.304634 C63.5526314,128.304634 61.9300117,127.853912 60.7581215,127.222893 C59.5862274,126.591873 58.8650627,125.600273 58.8650627,124.608673 L58.8650627,96.753685 C58.8650627,94.7321697 61.6072915,93.1391363 65.0029389,93.0607481 L65.3555374,93.0578156 C73.6758957,93.0578156 81.7085724,91.9710007 88.9205933,89.8925476 C93.7851944,88.4721222 98.2746964,86.5968552 102.225082,84.3136063 C106.0112,82.059967 109.166298,79.62603 111.600227,76.9216614 C109.166298,74.1271439 105.921051,71.6030769 102.044792,69.3494377 C92.1287766,63.5801201 78.9675217,60.5151672 64.994957,60.4250221 C51.0223961,60.334877 37.8611412,63.4899712 28.0352745,69.1691399 C18.1192608,74.8483124 12.8006716,82.4205399 12.8006716,90.5336456 C12.8006716,92.6069946 9.91601372,94.2296143 6.40033579,94.2296143 C4.20303726,94.2296143 2.25223064,93.5957794 1.09812093,92.614212 C0.405655026,92.0252762 0,91.3111496 0,90.5336456 L0,62.6787643 C0,56.0145454 2.95896721,49.5901337 8.58395767,43.9383698 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    opacity: 0.7,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0772295,15.7008886 C75.0833883,15.7008886 83.9156055,16.9377519 92.9400101,18.8741245 C93.2104468,17.3416497 93.3907352,16.0796131 93.4808807,15.0880117 C94.2921909,7.42563772 92.8498669,3.27894092 88.7933159,1.29573822 C86.3593853,0.0337002277 83.1141405,-0.326882124 79.9590454,0.304136872 C76.6236591,0.935155869 70.7642007,2.64792252 57.4226556,11.3920431 C54.8985796,13.104809 52.464648,14.7274292 50.4814453,16.0796127 C55.1690149,15.5387393 60.1192226,15.7008886 65.0772295,15.7008886 Z",
    id: "Vector",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-7)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,52.6787109 C0,54.7520591 2.88465825,56.3746781 6.40033579,56.3746781 C9.91601333,56.3746781 12.8006716,54.7520591 12.8006716,52.6787109 L12.8006716,80.5336948 C12.8006716,82.6070429 9.91601333,84.2296619 6.40033579,84.2296619 C2.88465825,84.2296619 0,82.6070429 0,80.5336948",
    id: "Vector",
    fillOpacity: 0.150000006,
    fill: "#1E0D50",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-225",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero",
    x: 126.25,
    y: 43.5336914,
    width: 21.625,
    height: 11.875
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-11)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-14)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-17)",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharityColor);
export default __webpack_public_path__ + "static/media/CharityColor.0e0596d32aded224ec93d863dac8b679.svg";
export { ForwardRef as ReactComponent };